import React from 'react'
import { useDispatch } from 'react-redux'
import { STATICS } from 'statics'
import { DRAWER_KEY } from 'app-constants'
import { setDrawer } from 'slices/drawer'
import { Button } from 'components/button'
import './style.scss'

export function SignalWeak({ connectionStatusData }) {
  const { signalWeakMessage } = connectionStatusData
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-signal-weak'>
      <span className='icon'>
        <STATICS.INFO />
      </span>
      <div className='info'>
        <p className='text'>{signalWeakMessage}</p>
      </div>
      <div className='actions'>
        <Button color='primary' size='large' onClick={handleClick}>
          Ok, entendi!
        </Button>
      </div>
    </div>
  )
}
